import { DashboardTabData } from "@/consts/Dashboard";

import CommonTab from "@/components/Common/Tab";
import CommonButton from "@/components/Common/Button";
import CommonImg from "@/components/Common/Img";

import FilterIcon from "@/assets/images/filter-icon.png";

type Props = {
  onSearch: () => void;
};
export default function DashboardTab({ onSearch }: Props) {
  return (
    <div className="w-full flex justify-between">
      <CommonTab variants="string" data={DashboardTabData} />
      <CommonButton
        className="px-3 py-1.5 bg-blue-ThermoFisher text-sm font-semibold gap-2"
        label="필터 적용하기"
        iconLeft={<CommonImg src={FilterIcon} alt="Filter" />}
        onClick={onSearch}
      />
    </div>
  );
}
